import { useEffect, useState, useRef } from "react"
import { AsyncTypeahead, Menu } from "react-bootstrap-typeahead"
import { apiService } from '../services/apiService';
import { Link, useNavigate } from 'react-router-dom';
import PlayerCardTypeahead from '../templates/PlayerCardTypeahead';

const PlayerSearchTypeahead = ({ onError, onSelect , isMobileView=false }) => {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([])

    const refTypeahead = useRef(null);

    const handleSearch = query => {
        setIsLoading(true);
        // `http://sports.fenix:8888/football/search_player?search_query=${query}`
        //`${import.meta.env.VITE_API_URL}/player/typeahead_search?search_query=${query}`
        apiService.apiGet(`${import.meta.env.VITE_API_URL}/player/typeahead_search?search_query=${query}`)
            .then((items) => {
                setOptions(items.data.players)
                setIsLoading(false)
            },
                error => {
                    onError(error);
                })
    }

    const playerSelectHandle = (selected) => {
        navigate('/playerdetail/' + selected[0].slug);
        refTypeahead.current.clear();
        if (onSelect) onSelect();
    }

    useEffect(() => {
        refTypeahead.current.clear();
    }, []);

    // Bypass client-side filtering by returning `true`. Results are already
    // filtered by the search endpoint, so no need to do it again.
    const filterBy = () => true

    return (
        <AsyncTypeahead
            ref={refTypeahead}
            filterBy={filterBy}
            id="async-players"
            isLoading={isLoading}
            labelKey={option => `${option.firstName} ${option.lastName}`}
            minLength={3}
            onSearch={handleSearch}
            options={options}
            onChange={(selected) => {
                // Handle selections...               
                playerSelectHandle(selected);
            }}
            placeholder="Search for a player..."
            inputProps={{
                className: `dark  bg-neutral-gray-900 border border-neutral-gray-900 fw-normal form-control ${isMobileView ? 'form-control-lg' : 'form-control-md' } w-100`,
                style: {
                    'backgroundColor': 'red',
                  }
            }}
            renderInput={({ inputRef, referenceElementRef, ...inputProps }) => (
                <input
                    {...inputProps}
                    ref={(input) => {
                        // Be sure to correctly handle these refs. In many cases, both can simply receive
                        // the underlying input node, but `referenceElementRef can receive a wrapper node if
                        // your custom input is more complex (See TypeaheadInputMulti for an example).
                        inputRef(input);
                        referenceElementRef(input);
                    }}
                />
            )}
            
            renderMenu={(results, menuProps) => (
                <Menu {...menuProps} className="py-1">
                    {results.map((result, index) => (
                        <Link
                            key={index}
                            to={`/playerdetail/${result.slug}`}
                            className="d-flex text-decoration-none flex-column justify-content-between bg-hover-dark-mode-300 bg-dark-mode-700 rounded-2 min-w-px-300 w-100 my-2"
                        >
                            <PlayerCardTypeahead data={result} noImg={false}/>
                        </Link>
                    ))}
                </Menu>
            )}

          
          
        />
    )
}
/* example-end */

export default PlayerSearchTypeahead
